import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { ProductKnowledgeArticle } from '../types';

type SaveArticleParams = {
  id?: string;
  title: string;
  description: string;
  markdown: string;
};

export default function useSaveProductKnowledgeArticle() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: SaveArticleParams) => {
      if (params.id) {
        return api.put<ProductKnowledgeArticle>(`/admin/product-knowledge/${params.id}`, {
          title: params.title,
          description: params.description,
          markdown: params.markdown,
        });
      }
      return api.post<ProductKnowledgeArticle>('/admin/product-knowledge', {
        title: params.title,
        description: params.description,
        markdown: params.markdown,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'product-knowledge'] });
    },
  });
}
